import { Plugin } from 'prosemirror-state';

import { AddMenuTabs, Browser } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import TabsNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          tab_view(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: TabsNodeView,
              stopDomEvents: true,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.tabs.title') as string,
            description: t('Lygo:Menu.tabs.description') as string,
            icon: Browser,
            addMenuIcon: AddMenuTabs,
            addMenuItemType: addMenuItemType.interactive_blocks,
            attrs: { src: null, alt: null },
            searchWords: ['tabs', 'interactive'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
